// export const API_ROOT = 'http://localhost/vet/api/';
//export const API_ROOT = 'http://192.168.1.16/vet/api/';
export const API_ROOT = 'https://api.cloudnine.biz.id/';
//export const API_ROOT = 'http://dev.cloudnine.biz.id/update/';
export const API_LOGIN = `${API_ROOT}login.php`;
export const LIST_OWNER = `${API_ROOT}owners.php`;
export const REKAM_MEDIS = `${API_ROOT}rekam_medis.php`;
export const REKAM_MEDIS_DRAFT = `${API_ROOT}rekam_medis_draft.php`;
export const REKAM_MEDIS_DETAIL = `${API_ROOT}rekam_medis_detail.php`;
export const UPLOAD_LAMPIRAN = `${API_ROOT}upload_lampiran.php`;
export const DELETE_LAMPIRAN = `${API_ROOT}delete_lampiran.php`;

export const GET_OWNERS = `${API_ROOT}get_owners.php`;
export const GET_PETS = `${API_ROOT}get_pets.php`;
